import { webAPI } from '../../../axiosInstance';


const getAllUsers = async () => {
  const clientToken = localStorage.getItem('clientToken');
  const response = await webAPI.get('users/profiles', {
    headers: {
      'x-token': clientToken || '', 
    },
  });
  return response.data;
};

const addUser = async (data: any) => {
  // console.log("🚀 ~ addUser ~ data:", data)
  const response = await webAPI.post('users/auth/signUp', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

// const deleteUser = async (data: any) => {
//   const response = await webAPI.delete(`/Users/delete/${data}`);
//   return response.data;
// };

export { getAllUsers, addUser };
